import ajax from "../utils/request";
const loginApi = {
  /********************************登陆管理*********************************** */
  // 登陆
  login(params) {
    return ajax({
      url: "/external_account/login",
      type: "post",
      params: params,
    });
  },
  // 获取应用列表
  getApplicationList(params) {
    return ajax({
      url: "/external_account/application/list",
      type: "get",
      params: params,
    });
  },
  // 修改应用
  updateApplication(params) {
    return ajax({
      url: "/external_account/application/edit",
      type: "post",
      params: params,
    });
  },
  // 获取操作日志记录
  getApplicationLogs(params) {
    return ajax({
      url: "/external_account/application/logs",
      type: "get",
      params: params,
    });
  },
};
export default loginApi;
